/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Input from '../../../adminv2/common/Input'
import CoreV2 from '@services/CoreV2'
import uuid from 'uuid/v4'
import CompanyModal from './Company.Modal'
import Alert from '../../../adminv2/common/Alert'
import { useDispatch } from 'react-redux'
import { showAlert } from '../alert/Alert.dux'
import { history } from '@services/History'
import _ from 'lodash'

export default function CompanyCommunicationForm(props) {
  const dispatch = useDispatch()
  let company = props.company
  let { formData, setFormData, initialFormData, setInitialFormData } = props

  const companyClient = CoreV2.companies
  CoreV2.updateHeaders({ apiKey: company.api_key })

  const [configuration, setCongifuration] = useState({})
  const [showModal, setShowModal] = useState(false)

  const { t } = useTranslation()

  const successAlertOpening = () => {
    dispatch(
      showAlert({
        text: t('generalUpdateSuccessMessage'),
        important: t('goodJob'),
        type: 'success',
      })
    )
  }

  const failureAlertOpening = () => {
    dispatch(
      showAlert({
        text: t('generalUpdatingErrorMEssage'),
        important: 'Oh snap!',
        type: 'danger',
      })
    )
  }

  useEffect(() => {
    if (company.api_key) {
      companyClient
        .getConfigurations(company.api_key)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            const { options } = res.data[0].attributes
            options.form = res.data[0].attributes.form
            options.id = res.data[0].attributes.id
            setCongifuration(options)
            return options
          } else {
            setCongifuration({})
          }
        })
        .then((options) => initializeFormData(options))
        .catch((err) => {
          failureAlertOpening()
        })
    }
  }, [])

  const initializeFormData = (options) => {
    let initial = {
      form: options?.form || '',
      concurrency_message: options?.concurrency_message.toString() || '',
      volumetry_message: options?.volumetry_message.toString() || '',
      last_message_schedule: options?.last_message_schedule.toString() || '',
      follow_up_message_schedule: options?.follow_up_message_schedule.toString() || '',
      sendable_from: options?.sendable_from.toString() || '',
      sendable_until: options?.sendable_until.toString() || '',
    }
    setInitialFormData(initial)
    setFormData(initial)
  }

  const formatData = (params) => {
    let result = {
      id: Object.keys(configuration).length === 0 ? uuid() : configuration.id,
      company_id: company.api_key,
      form: params.url,
      concurrency_message: parseInt(params.concurrence),
      volumetry_message: parseInt(params.professionalMessagePercentage),
      last_message_schedule: parseInt(params.lastMessageSendHours),
      follow_up_message_schedule: parseInt(params.lastMessageSegmentSendHours),
      sendable_from: parseInt(params.fromHours),
      sendable_until: parseInt(params.tohours),
    }

    return result
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = document.getElementById('communication-form')
    const formDataLocal = new FormData(form)
    const formProps = Object.fromEntries(formDataLocal)
    let params = formatData(formProps)

    if (company.api_key) {
      if (Object.keys(configuration).length === 0) {
        companyClient
          .postConfigurations(company.api_key, params)
          .then((res) => successAlertOpening())
          .then(setInitialFormData(formData))
          .catch((err) => {
            failureAlertOpening()
            window.alert(JSON.stringify(err.message, null, 2))
          })
      } else {
        companyClient
          .patchConfigurations(company.api_key, params)
          .then((res) => successAlertOpening())
          .then(setInitialFormData(formData))
          .catch((err) => {
            failureAlertOpening()
            window.alert(JSON.stringify(err.message, null, 2))
          })
      }
    }
  }

  const checkUnsavedChanges = () => {
    let isDirty = _.isEqual(formData, initialFormData)
    return isDirty
  }

  return (
    <div className="companies-form md-form ">
      {showModal ? (
        <CompanyModal
          close={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          onSave={(e) => {
            document.getElementById('communication-submit-btn').click()
            setShowModal(false)
          }}
          onReset={() => history.push('/companies')}
        />
      ) : null}
      <Alert timeOut={3000} />
      <form className="integration-form" id="communication-form" onSubmit={handleSubmit}>
        <h1>{t('communicationUserQuestionary')}</h1>
        <Input
          className="form-control"
          id="url"
          name="url"
          label="URL"
          defaultValue={configuration?.form || ''}
          onChange={(value) => setFormData({ ...formData, form: value })}
          required
        />
        <Input
          className="form-control"
          id="concurrence"
          name="concurrence"
          label={t('comunnicationConcurrencyMessage')}
          type="number"
          defaultValue={configuration?.concurrency_message || ''}
          onChange={(value) => setFormData({ ...formData, concurrency_message: value })}
          min="0"
          required
        />
        <Input
          className="form-control"
          id="professionalMessagePercentage"
          name="professionalMessagePercentage"
          label={t('comunnicationVolumetryMessage')}
          type="number"
          defaultValue={configuration?.volumetry_message || ''}
          onChange={(value) => setFormData({ ...formData, volumetry_message: value })}
          min="0"
          max="100"
          required
        />
        <Input
          className="form-control"
          id="lastMessageSendHours"
          name="lastMessageSendHours"
          label={t('comunnicationLastMessageSchedule')}
          type="number"
          defaultValue={configuration?.last_message_schedule || ''}
          onChange={(value) => setFormData({ ...formData, last_message_schedule: value })}
          min="0"
          required
        />
        <Input
          className="form-control"
          id="lastMessageSegmentSendHours"
          name="lastMessageSegmentSendHours"
          label={t('comunnicationFollowUpMessageSchedule')}
          type="number"
          defaultValue={configuration?.follow_up_message_schedule || ''}
          onChange={(value) => setFormData({ ...formData, follow_up_message_schedule: value })}
          min="0"
          required
        />
        <div>
          <label>{t('communicationShipmentAvailabilityTime')}</label>
          <div className="schedule-inputs-container">
            <span>{t('communicationSendableFrom')}</span>
            <Input
              className="form-control schedule-numeric-inputs"
              id="fromHours"
              name="fromHours"
              type="number"
              defaultValue={configuration?.sendable_from || ''}
              onChange={(value) => setFormData({ ...formData, sendable_from: value })}
              max="23"
              min="0"
              step="1"
              required
            />
            <span>{t('communicationHoursTo')}</span>
            <Input
              className="form-control schedule-numeric-inputs"
              id="tohours"
              name="tohours"
              type="number"
              max="23"
              min="0"
              defaultValue={configuration?.sendable_until || ''}
              onChange={(value) => setFormData({ ...formData, sendable_until: value })}
              step="1"
              required
            />
            <span>{t('communicationHours')}</span>
          </div>
        </div>

        <div className="companies-form--buttonsContainer">
          <button
            type="submit"
            className="btn btn-primary"
            id="communication-submit-btn"
            disabled={checkUnsavedChanges()}
          >
            {t('Guardar')}
          </button>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => {
              if (checkUnsavedChanges()) {
                history.push('/companies')
              } else {
                setShowModal(true)
              }
            }}
          >
            {t('Cancelar')}
          </button>
        </div>
      </form>
    </div>
  )
}
